import { render, staticRenderFns } from "./ClinicHealthCategoryDialog.vue?vue&type=template&id=cade8c0a&scoped=true"
import script from "./ClinicHealthCategoryDialog.vue?vue&type=script&lang=js"
export * from "./ClinicHealthCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicHealthCategoryDialog.vue?vue&type=style&index=0&id=cade8c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cade8c0a",
  null
  
)

export default component.exports